import { ActionReducerMap } from '@ngrx/store';

import { IAuthFeatureStateModel } from '@features/auth/models';
import { userReducer } from './user.reducer';

export const authFeatureReducers: ActionReducerMap<IAuthFeatureStateModel> = {
  user: userReducer,
};
